import React, { FunctionComponent, PropsWithChildren } from 'react'
import { CarlineId } from '../../entities/Carline'
import style from './selectCarlineButton.css'

export type Props = PropsWithChildren<{
    id: CarlineId
    selectCarline: (id: CarlineId, { forwardToModelPage }: { forwardToModelPage: boolean }) => void
    additionalStyle: string
}>

const SelectCarlineButton: FunctionComponent<Props> = (props) => {
    const { id, selectCarline, additionalStyle, children } = props

    const clickHandler = (): void => {
        selectCarline(id, {
            forwardToModelPage: true,
        })
    }

    const styles = additionalStyle
        ? style.button + " " + style[additionalStyle]
        : style.button

    return (
        <button
            onClick={clickHandler}
            className={styles}
            type="button"
            data-testid={`select-carline-button-${id.replace(/\\/g, '.')}`}
        >
            {children}
        </button>
    )
}

export default SelectCarlineButton
